module.exports = __webpack_public_path__ + "static/media/ekspozytory_01_B.b8b0c5d2.png";